import React, { Component } from 'react';
import {blue500, red500, greenA200} from 'material-ui/styles/colors';
import IconButton from 'material-ui/IconButton';
import Paper from 'material-ui/Paper';
import _ from 'lodash';
import ActionUpdate from 'material-ui/svg-icons/editor/mode-edit';
import ActionDelete from 'material-ui/svg-icons/action/delete';
import RaisedButton from 'material-ui/RaisedButton';
import EmptyIcon from 'material-ui/svg-icons/image/tune';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import withFirestorePath from "../components/withFirestorePath";
import DeleteDialog from "../components/DeleteDialog";
import LinearProgress from "../components/LinearProgress";

const styles = {
  root: {
    padding: 20,
    margin: '0 auto'
  },
  form: {
  },
  paper: {
    padding: 20,
  },
  gridList: {
    width: '100%',
    height: '100%',
    overflowY: 'auto',
  },
  saveButton: {
    marginTop: 15,
  }
};

const ModifiersEmpty = ({ onClick }) => (
  <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
    <EmptyIcon style={{ width: 400, height: 400, color: '#afafaf' }}/>
    <h4 style={{ color: '#afafaf'}}>You haven't added any modifiers</h4>
    <RaisedButton label="Add a Modifier" secondary onClick={onClick}/>
  </div>
);


const ModifiersTable = ({ restaurantId, modifiers, handleDelete, ...props}) => {
  return (
    <Table
      selectable={false}
    >

      <TableHeader
        adjustForCheckbox={false}
        displaySelectAll={false}
      >
        <TableRow>
          <TableHeaderColumn>Name</TableHeaderColumn>
          <TableHeaderColumn>Label</TableHeaderColumn>
          <TableHeaderColumn>Edit & Delete</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody
        displayRowCheckbox={false}
      >
        {modifiers.map((modifier, index) => (
          <TableRow key={index}>
            <TableRowColumn>{modifier.data().name}</TableRowColumn>
            <TableRowColumn>{modifier.data().label}</TableRowColumn>
            <TableRowColumn>
              <IconButton onTouchTap={() => props.router.push(`/${restaurantId}/edit-modifier/${modifier.id}`)}>
                <ActionUpdate/>
              </IconButton>
              <IconButton>
                <ActionDelete color={red500} onClick={() => handleDelete(modifier)} />
              </IconButton>
            </TableRowColumn>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}


class Modifiers extends Component{
  state = {
    modifiers: null,
    modifierToDelete: null,
    deleteDialogOpen: false,
  };

  async componentDidMount() {
    this.fetchData();
  }

  async fetchData() {
    const { restaurantPath } = this.props;
    try {
      const modifierSnaps = await restaurantPath
        .collection('modifiers')
        .orderBy("createdAt", "desc")
        .get();

      const modifiers = modifierSnaps.docs;

      this.setState({
        modifiers,
      });

    } catch (e) {
      console.log({ e })
    }
  }

  closeDeleteDialog() {
    this.setState({
      deleteDialogOpen: false,
    });
  }

  handleDeleteDialogClose = () => {
    this.closeDeleteDialog();
  };

  handleDeleteModifier = (modifier) => {
    this.setState({
      modifierToDelete: modifier,
      deleteDialogOpen: true,
    });
  };

  handleConfirmDelete = async () => {
    const { restaurantPath } = this.props;
    const { modifierToDelete } = this.state;
    await restaurantPath.collection('modifiers').doc(modifierToDelete.id).delete();
    this.setState({
      deleteDialogOpen: false,
      modifierToDelete: null,
    });
    this.fetchData();

  };

  renderDeleteDialog() {
    const { modifierToDelete, deleteDialogOpen } = this.state;
    return (
      <DeleteDialog
        title="Delete Modifier"
        open={deleteDialogOpen}
        onRequestClose={this.handleDeleteDialogClose}
        onConfirm={this.handleConfirmDelete}
        onDismiss={this.handleDeleteDialogClose}
      >
        {`Are you sure you want to delete '${modifierToDelete && modifierToDelete.data && modifierToDelete.data().name}'? This action cannot be undone.`}
      </DeleteDialog>
    );
  }


  render() {
    const { modifiers } = this.state;

    const { params } = this.props;
    const restaurantId = params.restaurantId;

    if(!modifiers ) return <LinearProgress secondary />;

    if(_.isEmpty(modifiers)) {
      return (
        <div style={styles.root}>
          <ModifiersEmpty onClick={() => this.props.router.push(`/${restaurantId}/create-modifier`)}/>
        </div>
      )
    }

    return (
      <div style={styles.root}>
        <h1>Modifiers</h1>
        <RaisedButton
          style={{ marginBottom: 5 }}
          label="Add Modifier"
          onTouchTap={() => this.props.router.push(`/${restaurantId}/create-modifier`)}
          secondary />
          <Paper style={styles.paper}>
            <ModifiersTable
              {...this.props}
              modifiers={modifiers}
              restaurantId={restaurantId}
              handleDelete={this.handleDeleteModifier}
            />
          </Paper>
        {this.renderDeleteDialog()}
      </div>
    );
  }
}

export default withFirestorePath(Modifiers);


// WEBPACK FOOTER //
// ./src/pages/Modifiers.js